import styled from 'styled-components';

export const ArrowIconContainer = styled.div`
  height: 15px;
`;

export const ArrowIcon = styled.img`
  scale: 0.5;
`;